import { Theme } from "@material-ui/core";

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function componentWithStyles({ spacing }: Theme) {
    return {
        confirmationOption: {
            marginTop: spacing(2),
        },
    };
}